import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TemperatureDerationCatalog } from '../models/temperature-deration-catalog.model';

@Component({
  selector: 'app-temperature-deration-plot',
  templateUrl: './temperature-deration-plot.component.html',
  standalone: false,
  styles: [':host { display: flex; flex: 1 1 0%; min-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemperatureDerationPlotComponent {
  @Input() tempDerations: TemperatureDerationCatalog[] = [];
  @Input() selectedTempDeration: Partial<TemperatureDerationCatalog> | null = null;
  @Input() modeSelected: 'single' | 'multiple' = 'single';
  @Input() temperatureUnit = '';
  @Input() downloadPlotName = 'temperature-deration-plot';

  readonly yAxisTitle = 'Deration Factor';
  private _cachedPlotData: Array<{ x: number[]; y: number[]; name?: string; showlegend: boolean }> = [];
  private _lastMode: 'single' | 'multiple' = 'single';
  private _lastTempDerationsRef: TemperatureDerationCatalog[] = [];
  private _lastSelectedRef: Partial<TemperatureDerationCatalog> | null = null;

  get xAxisTitle(): string {
    return `Temperature (${this.temperatureUnit})`;
  }

  get plotData(): Array<{ x: number[]; y: number[]; name?: string; showlegend: boolean }> {
    const hasChanged =
      this._lastMode !== this.modeSelected ||
      this._lastTempDerationsRef !== this.tempDerations ||
      this._lastSelectedRef !== this.selectedTempDeration;

    if (!hasChanged) {
      return this._cachedPlotData;
    }

    this._lastMode = this.modeSelected;
    this._lastTempDerationsRef = this.tempDerations;
    this._lastSelectedRef = this.selectedTempDeration;

    this._cachedPlotData = this.modeSelected === 'multiple'
      ? this.tempDerations.map((deration) => {
          const data = deration.temperatureDerationProfile ?? [];
          return {
            x: data.map((p) => p.temperature),
            y: data.map((p) => p.derationFactor),
            name: deration.name,
            showlegend: true
          };
        })
      : [
          {
            x: (this.selectedTempDeration?.temperatureDerationProfile ?? []).map((p) => p.temperature),
            y: (this.selectedTempDeration?.temperatureDerationProfile ?? []).map((p) => p.derationFactor),
            showlegend: false
          }
        ];

    return this._cachedPlotData;
  }
}
